// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as UseOnBlur from "../../../hook/UseOnBlur.bs.js";
import * as UseToggle from "../../../hook/UseToggle.bs.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Type_Header from "../../../type/Type_Header.bs.js";
import * as Atom_Textfield from "../../atom/Atom_Textfield.bs.js";
import * as UseClickOutside from "../../../hook/UseClickOutside.bs.js";
import * as Organism_Menu_Css from "./Organism_Menu_Css.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Animation_Ds from "../../particle/Particle_Animation_Ds.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";

var displayNoneMediumFlex = Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none");

var rulesContainer = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.position("static")]);

function Organism_Menu_Search(Props) {
  var screenReadersLabel = Props.screenReadersLabel;
  var styleButton = Props.styleButton;
  var placeholder = Props.placeholder;
  var onSubmit = Props.onSubmit;
  var view = Props.view;
  var id = Props.id;
  var match = React.useState(function () {
        return "";
      });
  var setQuery = match[1];
  var query = match[0];
  var match$1 = UseToggle.make(undefined, undefined, undefined, undefined);
  var close = match$1.close;
  var state = match$1.state;
  var ref = React.useRef(null);
  UseClickOutside.make(ref, close);
  UseOnBlur.make(ref, close);
  var onChange = function (value) {
    Curry._1(setQuery, (function (param) {
            return value;
          }));
  };
  var onSubmit$1 = function ($$event) {
    $$event.preventDefault();
    Curry._1(onSubmit, query);
  };
  var style = Curry._1(styleButton, state);
  return React.createElement(Atom_Column.make, {
              children: null,
              display: displayNoneMediumFlex,
              id: id,
              kind: /* ItemList */4,
              ref_: ref,
              rules: rulesContainer
            }, React.createElement(Atom_Cta.Button.make, {
                  onClick: match$1.toggle,
                  screenReadersLabel: screenReadersLabel,
                  style: style
                }), state ? null : React.createElement(Atom_Row.make, {
                    alignItems: Particle_Screen_Constants.alignItemsCenter,
                    animation: Particle_Animation_Ds.Corporate.searchForm,
                    background: view.searchFormBackground,
                    children: null,
                    height: Type_Header.Constants.heightStyle,
                    kind: {
                      TAG: /* Form */6,
                      _0: onSubmit$1
                    },
                    rules: Organism_Menu_Css.rulesSearchForm
                  }, React.createElement(Atom_Textfield.make, {
                        value: query,
                        placeholder: placeholder,
                        onChange: onChange,
                        required: true,
                        style: view.searchFormStyle,
                        autoFocus: true,
                        autoSize: Particle_Screen_Constants.autoSizeAllPlaceAvailable,
                        focusOutline: /* None */19
                      }), React.createElement(Atom_Cta.Button.make, {
                        screenReadersLabel: screenReadersLabel,
                        style: Curry._1(styleButton, /* Off */1),
                        type_: "submit"
                      })));
}

var make = Organism_Menu_Search;

export {
  displayNoneMediumFlex ,
  rulesContainer ,
  make ,
}
/* displayNoneMediumFlex Not a pure module */
